import { render, staticRenderFns } from "./BatchStatements.vue?vue&type=template&id=92b99fca"
import script from "./BatchStatements.vue?vue&type=script&lang=js"
export * from "./BatchStatements.vue?vue&type=script&lang=js"
import style0 from "./BatchStatements.vue?vue&type=style&index=0&id=92b99fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports